import { useQuery } from 'react-query';
import { EventFeedbackAPI } from 'api/admin/eventFeedback';
import { EVENT_FEEDBACK } from 'helpers/constants';

export default function useEventFeedback({ judgeId, eventParticipationId }) {
  return useQuery([EVENT_FEEDBACK, judgeId, eventParticipationId], () =>
    EventFeedbackAPI.getOne({ judgeId, eventParticipationId })
  );
}
